( function () {
	'use strict';

	var DEFAULT_HORIZONTAL_SCALE = 0.93;
	var DEFAULT_PIN_WIDTH = 24;
	var DEFAULT_PIN_HEIGHT = 60;
	var DEFAULT_PIN_TIP_X = 12.1049 / DEFAULT_PIN_WIDTH;
	var DEFAULT_PIN_TIP_Y = 51.7631 / DEFAULT_PIN_HEIGHT;

	function parseConfig( rawConfig ) {
		if ( ! rawConfig ) {
			return null;
		}

		try {
			return JSON.parse( rawConfig );
		} catch ( error ) {
			return null;
		}
	}

	function mercY( value ) {
		var clamped = Math.max( -85, Math.min( 85, value ) );
		var radians = clamped * Math.PI / 180;
		return Math.log( Math.tan( Math.PI / 4 + radians / 2 ) );
	}

	function formatPositionValue( percent, pixelOffset ) {
		var safePercent = percent.toFixed( 4 );
		var safeOffset = pixelOffset.toFixed( 3 );

		if ( 0 === pixelOffset ) {
			return safePercent + '%';
		}

		if ( pixelOffset > 0 ) {
			return 'calc(' + safePercent + '% + ' + safeOffset + 'px)';
		}

		return 'calc(' + safePercent + '% - ' + Math.abs( pixelOffset ).toFixed( 3 ) + 'px)';
	}

	function project( geo, viewBoxWidth, viewBoxHeight, lng, lat, horizontalScale ) {
		var lngNorm = lng;
		var x;
		var centerX;
		var yTop;
		var yBottom;
		var y;

		while ( lngNorm < geo.x1 ) {
			lngNorm += 360;
		}

		while ( lngNorm > geo.x2 ) {
			lngNorm -= 360;
		}

		x = ( lngNorm - geo.x1 ) / ( geo.x2 - geo.x1 ) * viewBoxWidth;
		centerX = viewBoxWidth / 2;
		x = centerX + ( x - centerX ) * horizontalScale;
		yTop = mercY( geo.y1 );
		yBottom = mercY( geo.y2 );
		y = ( yTop - mercY( lat ) ) / ( yTop - yBottom ) * viewBoxHeight;

		return {
			x: x,
			y: y,
		};
	}

	function initNetworkMap( wrap ) {
		var config = parseConfig( wrap.getAttribute( 'data-network-map-config' ) );
		var horizontalScale;
		var pinWidth;
		var pinHeight;
		var pinTipX;
		var pinTipY;
		var pinOffsetX;
		var pinOffsetY;
		if ( ! config || ! config.markers || ! config.markers.length ) {
			return;
		}

		horizontalScale = config.projection && 'number' === typeof config.projection.horizontalScale ? config.projection.horizontalScale : DEFAULT_HORIZONTAL_SCALE;
		pinWidth = config.projection && 'number' === typeof config.projection.pinWidth ? config.projection.pinWidth : DEFAULT_PIN_WIDTH;
		pinHeight = config.projection && 'number' === typeof config.projection.pinHeight ? config.projection.pinHeight : DEFAULT_PIN_HEIGHT;
		pinTipX = config.projection && 'number' === typeof config.projection.pinTipX ? config.projection.pinTipX : DEFAULT_PIN_TIP_X;
		pinTipY = config.projection && 'number' === typeof config.projection.pinTipY ? config.projection.pinTipY : DEFAULT_PIN_TIP_Y;
		pinOffsetX = ( 0.5 - pinTipX ) * pinWidth;
		pinOffsetY = ( 1 - pinTipY ) * pinHeight;

		var stage = wrap.querySelector( '.gardp-network-map__map-stage' );
		var pinsLayer = wrap.querySelector( '.gardp-network-map__pins' );
		var tooltip = wrap.querySelector( '.gardp-network-map__tooltip' );
		var tooltipContent = wrap.querySelector( '.gardp-network-map__tooltip-content' );
		var tooltipClose = wrap.querySelector( '.gardp-network-map__tooltip-close' );
		var markerCards = wrap.querySelectorAll( '.gardp-network-map__card' );
		var activePin = null;
		var activeMarkerId = '';

		if ( ! stage || ! pinsLayer || ! tooltip || ! tooltipContent || ! tooltipClose || ! markerCards.length ) {
			return;
		}

		function getMarkerContent( markerId ) {
			var card = wrap.querySelector( '.gardp-network-map__card[data-marker-id="' + markerId + '"] .gardp-network-map__card-content' );
			return card ? card.innerHTML : '';
		}

		function setActivePin( nextPin ) {
			if ( activePin ) {
				activePin.classList.remove( 'is-active' );
				activePin.setAttribute( 'aria-expanded', 'false' );
			}

			activePin = nextPin;

			if ( activePin ) {
				activePin.classList.add( 'is-active' );
				activePin.setAttribute( 'aria-expanded', 'true' );
			}
		}

		function positionTooltip( pin ) {
			var stageRect;
			var pinRect;
			var tooltipWidth;
			var tooltipHeight;
			var horizontalPadding = 24;
			var verticalPadding = 24;
			var gap = 16;
			var left;
			var top;
			var maxLeft;
			var maxTop;

			if ( ! pin || tooltip.hidden ) {
				return;
			}

			stageRect = stage.getBoundingClientRect();
			pinRect = pin.getBoundingClientRect();
			tooltipWidth = tooltip.offsetWidth;
			tooltipHeight = tooltip.offsetHeight;

			left = pinRect.left - stageRect.left + ( pinRect.width / 2 ) - ( tooltipWidth / 2 );
			top = pinRect.top - stageRect.top - tooltipHeight - gap;

			maxLeft = Math.max( horizontalPadding, stage.clientWidth - tooltipWidth - horizontalPadding );
			maxTop = Math.max( verticalPadding, stage.clientHeight - tooltipHeight - verticalPadding );

			left = Math.min( Math.max( horizontalPadding, left ), maxLeft );
			top = Math.min( Math.max( verticalPadding, top ), maxTop );

			tooltip.style.left = left + 'px';
			tooltip.style.top = top + 'px';
		}

		function closeTooltip() {
			tooltip.hidden = true;
			tooltip.setAttribute( 'aria-hidden', 'true' );
			tooltipContent.innerHTML = '';
			tooltip.style.left = '';
			tooltip.style.top = '';
			activeMarkerId = '';
			setActivePin( null );
		}

		function openTooltip( markerId, pin ) {
			var content = getMarkerContent( markerId );

			if ( ! content ) {
				return;
			}

			tooltipContent.innerHTML = content;
			tooltip.hidden = false;
			tooltip.setAttribute( 'aria-hidden', 'false' );
			activeMarkerId = markerId;
			setActivePin( pin );
			positionTooltip( pin );
		}

		config.markers.forEach( function ( marker ) {
			var point = project( config.geo, config.vbW, config.vbH, marker.lng, marker.lat, horizontalScale );
			var pin = document.createElement( 'button' );

			pin.type = 'button';
			pin.className = 'gardp-network-map__pin';
			pin.style.left = formatPositionValue( point.x / config.vbW * 100, pinOffsetX );
			pin.style.top = formatPositionValue( point.y / config.vbH * 100, pinOffsetY );
			pin.setAttribute( 'data-marker-id', marker.id );
			pin.setAttribute( 'aria-label', marker.label );
			pin.setAttribute( 'aria-expanded', 'false' );
			pin.innerHTML = '<span class="screen-reader-text">' + marker.label + '</span>';

			pin.addEventListener( 'mouseover', function () {
				// if ( activePin === pin ) {
				// 	closeTooltip();
				// 	return;
				// }

				openTooltip( marker.id, pin );
			} );

			pinsLayer.appendChild( pin );
		} );

		tooltipClose.addEventListener( 'click', function () {
			closeTooltip();
		} );

		document.addEventListener( 'click', function ( event ) {
			if ( tooltip.hidden ) {
				return;
			}

			if ( wrap.contains( event.target ) && ( event.target.closest( '.gardp-network-map__pin' ) || event.target.closest( '.gardp-network-map__tooltip' ) ) ) {
				return;
			}

			closeTooltip();
		} );

		document.addEventListener( 'keydown', function ( event ) {
			if ( 'Escape' === event.key ) {
				closeTooltip();
			}
		} );

		window.addEventListener( 'resize', function () {
			if ( activePin && activeMarkerId ) {
				positionTooltip( activePin );
			}
		} );
	}

	function boot() {
		document.querySelectorAll( '.gardp-network-map[data-network-map-config]' ).forEach( initNetworkMap );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot, { once: true } );
	} else {
		boot();
	}
}() );